export default __webpack_public_path__ + "static/media/registrazione-incontri-nc.b91ce86e.svg";